<div class="wrapper flex flex-col justify-between overflow-x-hidden">
  <div class="heading text-type-2 mb-[40px]">
    {{ data?.id ? data?.title : 'Create submittal' }}
  </div>
  @if (!data?.id) {
    <div class="details scrollbar-hide flex-1">
      <app-dropdown
        (addNewClicked)="openAddRegistryDialog($event)"
        (checkForErrors)="checkForErrors($event)"
        [enableAddNew]="canAddRegistry"
        [enableRegistryDetailedOptionView]="true"
        [enableSearch]="true"
        [error]="errorMessages['registry']"
        [options]="submittalsRegistryOptions"
        [parentFormGroup]="form"
        addNewLabel="Add registry entry"
        class="w-full mb-[20px]"
        controlName="registry"
        label="registry"
        />
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['title']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="title"
        label="title"
        />
      <app-view-field
        [value]="form?.controls['submittal_no']?.value"
        class="w-full mb-[30px] adjust-label"
        label="submittal No"
        />
      <app-view-field
        [value]="form?.controls['spec_reference_no']?.value"
        class="w-full mb-[30px] adjust-label"
        label="Spec Reference No"
        />
      <app-date-picker
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['due_date']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="due_date"
        label="due date"
        />
      <app-text-area
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['description']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="description"
        label="description"
        />
      @for (controlName of getAttachmentTypeKeys(); track controlName) {
        <div
          class="mb-[20px]"
          >
          @if (!isAttachmentSelected(controlName)) {
            <app-dropdown
              [controlName]="controlName"
              [error]="errorMessages[controlName]"
              [label]="'Attachment Type'"
              [options]="attachmentTypeOptions"
              [parentFormGroup]="form"
              class="w-full mb-[10px]"
            ></app-dropdown>
          }
          <!-- Only show pictures section if the type is selected -->
          @if (isAttachmentSelected(controlName)) {
            <app-pictures-section-with-tags
              (onDelete)="deletePicture($event)"
              [add]="true"
              [label]="reMappingTag[form.get(controlName)?.value]"
              [pictures]="mediaFiles"
              [tags]="form.get(controlName)?.value"
              class="pictures-section mb-[40px] mt-[20px]"
              />
          }
        </div>
      }
      <div class="add-item text-type-9 cursor-pointer flex justify-start items-center">
        @if (!hideLink) {
          <span (click)="addAnotherType()" class="flex justify-start items-center">
            <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
            Add another type
          </span>
        }
      </div>
    </div>
    <div class="action-section w-full flex justify-between items-center gap-[10px] mt-[40px]"
      >
      <app-secondary-button
        (handleClick)="save()"
        [isDisabled]="!isFormDirty"
        class="w-1/2"
        >
        Save
      </app-secondary-button>
      <app-primary-button
        (handleClick)="submit()"
        [isDisabled]="!isFormDirty"
        class="w-1/2"
        >
        Submit
      </app-primary-button>
    </div>
  }
  @if (data?.id) {
    <mat-tab-group
      #snTabGroup
      (selectedTabChange)="onTabChange($event)"
      [selectedIndex]="selectedTabIndex"
      class="contents-tab-group flex-1"
      >
      <mat-tab label="Details">
        <div
          class="details scrollbar-hide h-full flex-1 pt-[40px] w-full flex flex-col overflow-x-hidden justify-between">
          @if (contractorRole) {
            <div class="form">
              <app-dropdown
                (addNewClicked)="openAddRegistryDialog($event)"
                (checkForErrors)="checkForErrors($event)"
                [enableAddNew]="canAddRegistry"
                [enableRegistryDetailedOptionView]="true"
                [enableSearch]="true"
                [error]="errorMessages['registry']"
                [options]="submittalsRegistryOptions"
                [parentFormGroup]="form"
                addNewLabel="Add registry entry"
                class="w-full mb-[20px]"
                controlName="registry"
                label="registry"
                />
              <app-text-input
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['title']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="title"
                label="title"
                />
              <app-view-field
                [value]="form?.controls['submittal_no']?.value"
                class="w-full mb-[30px] adjust-label"
                label="submittal No"
                />
              <app-view-field
                [value]="form?.controls['spec_reference_no']?.value"
                class="w-full mb-[30px] adjust-label"
                label="Spec Reference No"
                />
              <app-date-picker
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['due_date']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="due_date"
                label="due date"
                />
              <app-text-area
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['description']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="description"
                label="description"
                />
              @for (controlName of getAttachmentTypeKeys(); track controlName) {
                <div
                  class="mb-[20px]"
                  >
                  @if (!isAttachmentSelected(controlName) && !ifFormDisabled) {
                    <app-dropdown
                      [controlName]="controlName"
                      [error]="errorMessages[controlName]"
                      [label]="'Attachment Type'"
                      [options]="attachmentTypeOptions"
                      [parentFormGroup]="form"
                      class="w-full mb-[10px]"
                      />
                  }
                  <!-- Only show pictures section if the type is selected -->
                  @if (isAttachmentSelected(controlName)) {
                    <app-pictures-section-with-tags
                      (onDelete)="deletePicture($event)"
                      [add]="true"
                      [isEditable]="!ifFormDisabled"
                      [label]="reMappingTag[form.get(controlName)?.value]"
                      [pictures]="mediaFiles"
                      [tags]="form.get(controlName)?.value"
                      class="pictures-section mb-[40px] mt-[20px]"
                      />
                  }
                </div>
              }
              @if (!ifFormDisabled) {
                <div class="add-item text-type-9 cursor-pointer flex justify-start items-center">
                  @if (!hideLink) {
                    <span (click)="addAnotherType()" class="flex justify-start items-center">
                      <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
                      Add another type
                    </span>
                  }
                </div>
              }
            </div>
            <div
              [ngClass]="{'mt-[40px]' : contractorRole}"
              class="action-section w-full flex justify-between items-center gap-[10px]"
              >
              @if (contractorRole) {
                <app-secondary-button
                  (handleClick)="save()"
                  [isDisabled]="!isFormDirty"
                  class="flex-1"
                  >
                  Save
                </app-secondary-button>
              }
              @if (displayNextActions) {
                @for (action of primaryActions; track action) {
                  <app-primary-button
                    (handleClick)="executeState(action)"
                    [color]="action?.options?.styles?.color"
                    class="action-btn flex-1"
                    >
                    {{ action?.options?.label }}
                  </app-primary-button>
                }
                @if (menuActions.length) {
                  <div
                    [matMenuTriggerFor]="nextActionsMenu"
                    class="submittal-menu-button">
                    <mat-icon class="menu">more_horiz</mat-icon>
                  </div>
                }
              }
            </div>
            <mat-menu #nextActionsMenu="matMenu">
              @for (action of menuActions; track action) {
                <button
                  (click)="executeState(action)"
                  mat-menu-item
                  >
                  {{ action?.options?.label }}
                </button>
              }
            </mat-menu>
          } @else {
            <div class="submittal-details">
              <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                <div class="label w-full uppercase">
                  Status:
                </div>
                <div class="value w-full text-type-11">
                  <div
                    [ngClass]="data?.status && statusMap[data?.status] ? [statusMap[data.status].bgColor, statusMap[data.status].textColor] : []"
                    class="status-chip px-[14px] rounded-full">
                    {{ statusMap[data?.status]?.label }}
                  </div>
                </div>
              </div>
              <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                <div class="label w-full uppercase">
                  registry:
                </div>
                <div class="value w-full text-type-11">
                  {{ data?.['submittal_log']?.title }}
                </div>
              </div>
              <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                <div class="label w-full uppercase">
                  Spec #:
                </div>
                <div class="value w-full text-type-11">
                  {{ data?.['submittal_log']?.section_no }}-{{ data?.['submittal_log']?.sub_section_no }}
                </div>
              </div>
              <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                <div class="label w-full uppercase">
                  Submittal No:
                </div>
                <div class="value w-full text-type-11">
                  {{ data?.submittal_no }}
                </div>
              </div>
              @if (data?.cc_users?.length) {
                <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                  <div class="label w-full uppercase">
                    CC Users:
                  </div>
                  <div class="value w-full text-type-11">
                    @for (user of data.cc_users; track user) {
                      <div class="details mt-[20px]">
                        <div class="user flex flex-row gap-[8px]">
                          <div class="user-avatar">
                            {{ user?.first_name?.charAt(0) }}
                          </div>
                          <div class="user-details flex flex-col">
                            <div class="user-name">
                              {{ user?.email }}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (data?.reviewers?.length) {
                <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                  <div class="label w-full uppercase">
                    Reviewers:
                  </div>
                  <div class="value w-full text-type-11">
                    @for (user of data.reviewers; track user) {
                      <div class="details mt-[20px]">
                        <div class="user flex flex-row gap-[8px]">
                          <div class="user-avatar">
                            {{ user?.first_name?.charAt(0) }}
                          </div>
                          <div class="user-details flex flex-col">
                            <div class="user-name">
                              {{ user?.email }}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                <div class="label w-full uppercase">
                  Description:
                </div>
                <div class="value w-full text-type-11">
                  {{ data?.description || 'N/A' }}
                </div>
              </div>
              @if (data?.attachments?.length) {
                @for (controlName of getAttachmentTypeKeys(); track controlName) {
                  <div class="row-details flex flex-col gap-[12px] mb-[20px]">
                    <div class="label w-full uppercase">
                      Attachment Type:
                    </div>
                    <div class="value w-full text-type-11">
                      {{ reMappingTag[form.get(controlName)?.value] }}
                    </div>
                  </div>
                  <div class="row-details flex flex-col gap-[12px] mb-[40px]">
                    <div class="value w-full text-type-11">
                      @if (isAttachmentSelected(controlName)) {
                        <app-pictures-section-with-tags
                          (onDelete)="deletePicture($event)"
                          [add]="true"
                          [isEditable]="false"
                          [label]="reMappingTag[form.get(controlName)?.value]"
                          [pictures]="mediaFiles"
                          [tags]="form.get(controlName)?.value"
                          class="pictures-section mb-[40px]"
                          />
                      }
                    </div>
                  </div>
                }
              }
              <hr class="hr-line" />
              @if (actionsOptions?.length) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [error]="errorMessages['actions']"
                  [options]="actionsOptions"
                  [parentFormGroup]="form"
                  [placeholder]="'Take action on this submital'"
                  class="w-full mb-[20px]"
                  data-testid="submittal-actions-select"
                  controlName="actions"
                  label="Actions"
                  />
              }
              @if (form.controls?.['actions_select_from_previous_responses'] && responseList?.length) {
                <div
                  class="flex flex-row justify-between items-center mb-[30px] gap-[20px] w-full">
                  <div class="label text-type-13 ">
                    Select from previous responses:
                  </div>
                  <mat-slide-toggle
                    (change)="onToggle($event)"
                    data-testid="submittal-copy-response-toggle"
                    [checked]="form.controls['actions_select_from_previous_responses'].value"
                    [disableRipple]="false"
                    class="slide-toggle-btn"
                    color="primary"
                    />
                </div>
              }
              @if (form?.controls?.['actions_response_dropdown']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [enableMultiple]="true"
                  [error]="errorMessages['actions_response_dropdown']"
                  [options]="responseList"
                  [parentFormGroup]="form"
                  [selectionString]="form.controls['actions_response_dropdown']?.value?.length > 1 ? 'Responses' : 'Response'"
                  [showCount]="true"
                  class="w-full mb-[20px]"
                  controlName="actions_response_dropdown"
                  data-testid="submittal-copy-response-select"
                  label="Select response from"
                  />
              }
              @if (form?.controls?.['actions__reviewers']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [enableMultiple]="true"
                  [enableSearch]="true"
                  [error]="errorMessages['actions__reviewers']"
                  [options]="userOptions"
                  [parentFormGroup]="form"
                  [selectionString]="form.controls['actions__reviewers']?.value?.length > 1 ? 'Reviewers' : 'Reviewer'"
                  [showCount]="true"
                  class="w-full mb-[20px]"
                  controlName="actions__reviewers"
                  label="reviewers"
                  />
              }
              @if (form?.controls?.['actions__fyi_users']) {
                <app-dropdown
                  (checkForErrors)="checkForErrors($event)"
                  [enableMultiple]="true"
                  [enableSearch]="true"
                  [error]="errorMessages['actions__fyi_users']"
                  [options]="userOptions"
                  [parentFormGroup]="form"
                  [selectionString]="form.controls['actions__fyi_users']?.value?.length > 1 ? 'Users' : 'User'"
                  [showCount]="true"
                  class="w-full mb-[20px]"
                  controlName="actions__fyi_users"
                  label="Fyi users"
                  />
              }
              <app-text-area
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['actions_comments']"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="actions_comments"
                data-testid="submittal-action-comments"
                label="Comments"
                />
              @if (form?.controls?.['actions_attachments']) {
                <app-pictures-section-with-tags
                  (onDelete)="deleteActionPicture($event)"
                  [add]="true"
                  [pictures]="mediaFiles"
                  class="pictures-section mb-[40px]"
                  data-testid="submittal-action-attachments"
                  label="Attachments"
                  />
              }
            </div>
            <div class="action-section w-full flex justify-between items-center gap-[10px]"
              >
              <app-primary-button
                (handleClick)="execute()"
                [isDisabled]="!selectedAction?.length"
                class="flex-1"
                data-testid="submittal-action-submit"
                >
                Submit
              </app-primary-button>
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab label="Discussion">
        <app-submittals-workflow [data]=data />
      </mat-tab>
    </mat-tab-group>
  }
</div>
